export default {
	inserted(el) {
		el.addEventListener('click', function (e) {
			const targetId = el.getAttribute('href');
			if(targetId && targetId.startsWith('#')) {
				e.preventDefault();
				const targetElement = document.querySelector(targetId);
				if(targetElement) {
					window.scrollTo({
						top: targetElement.offsetTop,
						behavior: 'smooth'
					});
				}
			}
		});
	}
};